module.exports = __webpack_public_path__ + "static/img/guide-wxpay.407286c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invoice-manage/guide-wxpay.png
// module id = VKQS
// module chunks = 4